const sanitizeForGraphite = str => String(str).replace(/\./, '-');
const prefix = client => `${client ? `${client}.` : ''}api`;

const increment = name => {
  if (__SERVER__ && global.statsd) {
    global.statsd.increment(name);
  }
};

const histogram = (name, duration) => {
  if (__SERVER__ && global.statsd) {
    global.statsd.histogram(name, duration);
  }
};

const histogramTimer = name => {
  const hrStart = process.hrtime.bigint();
  return {
    end: () => {
      const hrEnd = process.hrtime.bigint();
      histogram(name, Number(hrEnd - hrStart) / 1e6);
    },
  };
};

const trackApiRequest = (client, event) => {
  if (!event || !event.method || !event.name) {
    console.warn('Cannot log event', event); // eslint-disable-line no-console
    return;
  }

  // counter: <namespace>.<client name>.api.<name>.requested
  // counter: <namespace>.<client name>.api._global.requested
  increment(
    `${prefix(client)}.${event.method.toLowerCase()}.${sanitizeForGraphite(event.name.toLowerCase())}.requested`
  );
  increment(`${prefix(client)}.${event.method.toLowerCase()}._global.requested`);
};

const trackApiResult = (client, event) => {
  if (!event || !event.method || !event.name) {
    console.warn('Cannot log event', event); // eslint-disable-line no-console
    return;
  }
  // timer: <namespace>.<client name>.api.<verb>.<name>.response_time
  // timer: <namespace>.<client name>.api.<verb>._global.response_time
  histogram(
    `${prefix(client)}.${event.method.toLowerCase()}.${sanitizeForGraphite(event.name.toLowerCase())}.response_time`,
    event.duration
  );
  histogram(`${prefix(client)}.${event.method.toLowerCase()}._global.response_time`, event.duration);

  // counter: <namespace>.<client name>.api.<verb>.<name>.http.<code>
  // counter: <namespace>.<client name>.api.<verb>._global.http.<code>
  if (event.httpStatus) {
    increment(
      `${prefix(client)}.${event.method.toLowerCase()}.${sanitizeForGraphite(event.name.toLowerCase())}.http.${
        event.httpStatus
      }`
    );
    increment(`${prefix(client)}.${event.method.toLowerCase()}._global.http.${event.httpStatus}`);
  }

  // counter: <namespace>.<client name>.api.<verb>.<name>.error.<code>
  // counter: <namespace>.<client name>.api.<verb>._global.error.<code>
  if (event.code) {
    increment(
      `${prefix(client)}.${event.method.toLowerCase()}.${sanitizeForGraphite(event.name.toLowerCase())}.error.${
        event.code
      }`
    );
    increment(`${prefix(client)}.${event.method.toLowerCase()}._global.error.${event.code}`);
  }
};

export { increment };
export { histogram };
export { trackApiRequest };
export { trackApiResult };
export { histogramTimer };
